<template>
  <v-chip @click="$emit('claim')" color="green" append-icon="mdi-clock">
    <v-btn variant="text" :loading="loading">
      <template v-if="isPurchaseHold">
        Add Waitlisted signup {{ personName }} to cart
        {{ formatRawCost(priceCents || 0) }}
      </template>
      <template v-else> Claim Waitlist {{ personName }} </template>
      <span
        v-if="expiresOn"
        :class="
          countdown.isUrgent.value
            ? 'ml-2 text-error font-weight-bold'
            : 'ml-2 text-warning'
        "
      >
        ({{ countdown.timeRemaining.value }})
      </span>
    </v-btn>
  </v-chip>
</template>

<script setup lang="ts">
import { useCountdown } from "@/composables/useCountdown";
import { useUtility } from "@/composables/useUtility";

const { formatRawCost } = useUtility();

const props = defineProps<{
  personName: string | undefined;
  expiresOn: Date | undefined | null;
  loading: boolean;
  isPurchaseHold: boolean;
  priceCents: number | null;
}>();

defineEmits<{
  claim: [];
}>();

const countdown = useCountdown(props.expiresOn || undefined);
</script>
